// extracted by mini-css-extract-plugin
export var banner = "_1k-0";
export var icon = "_1k-1";
export var message = "_1k-2";